import React from "react";


function MenuAula1() {
  

  return (
    <>
      <nav>
        <ul>
          <li><a href="#o-que-veremos">O que veremos</a></li>
          <li><a href="#pre-processadores">Pré-processadores</a></li>
          <li><a href="#vantagens-desvantagens">Vantagens e Desvantagens</a></li>
        </ul>
      </nav>
    </>
  );
}

export default MenuAula1;


